/* global $:false */

import DefinitionConditionP from './recordm.presenter.definition.condition.js';
import DefinitionFieldConditionListV from '../view/recordm.view.definition.conditionlist.js';
import DefinitionFieldP from './recordm.presenter.definition.field.js';
import DefinitionFieldsNanny from './recordm.presenter.definition.fieldnanny.js';

var DefinitionConditionListP = function(core, parent, $container, field, readonly) {

    var _fieldNanny = new DefinitionFieldsNanny(core);
    var _condNanny = new DefinitionFieldsNanny(core);

    var _fieldBuilder = new DefinitionFieldP.NewFieldBuilder(core, {
       expand: () => {
          parent.expand();
       }
    });
    var _conditionBuilder = new NewConditionBuilder(core, {
       expand: () => {
          parent.expand();
       }
    });

    const _removeCondition = function (id){
        _condNanny.removeChild(id);
        window.console.log(`removed condition with id ${id}`);
    }

    var view = new DefinitionFieldConditionListV(core, $container, field, {

        top_field_add: function(){
            var newField = _fieldBuilder.buildFor(_fieldNanny);

            core.translate('recordm.definition', newField.content());

            view.addTopField(newField);
            _fieldNanny.addChildAfter(0, newField);
        },

        top_field_drop: function($dropedElement){
            var oldNanny = $dropedElement.data('nanny');

            //remove the Presenter from the oldNanny
            var hisPresenter = oldNanny.removeChild($dropedElement.data('fieldId'));

            //set the new nanny, both in the Presenter and the data attribute
            hisPresenter.setNanny(_fieldNanny);
            $dropedElement.data('nanny', _fieldNanny);

            //add to our fields
            view.addTopField(hisPresenter);
            _fieldNanny.addChildAfter(0, hisPresenter);
        },

        bottom_condition_add: function(){
            const newCondition = _conditionBuilder.build('', [], false, {
                remove: _removeCondition
            });

            core.translate('recordm.definition', newCondition.content());

            view.addBottomCondition(newCondition);
            _condNanny.addChild(newCondition);
        }

    });

    var _getFieldDefs = function() {
        var fieldDefs = [];

        _fieldNanny.getChildren().forEach(function(fieldP) {
            fieldDefs.push(fieldP.getFieldDef());
        });

        _condNanny.getChildren().forEach(function(condP) {
            var confPModel = condP.getModel();
            if (confPModel && confPModel.length > 0) {
                confPModel.forEach(function(fieldDef) {
                    fieldDefs.push(fieldDef);
                });
            }
        });

        if (fieldDefs.length === 0) fieldDefs = null;

        return fieldDefs;
    };

    var _init = function() {

        var _unconditionalFields = [];
        var _conditionalFieldsMap = {};

        view.build();

        if (field.fields && field.fields.length > 0) {

            field.fields.forEach(function(childField) {
                if (!childField.condition || childField.condition === '') {
                    _unconditionalFields.push(childField);
                } else {
                    if (_conditionalFieldsMap[childField.condition]) {
                        _conditionalFieldsMap[childField.condition].push(childField);
                    } else {
                        _conditionalFieldsMap[childField.condition] = [childField];
                    }
                }
            });

            //we had the fields in inverse order, because the view only has addTopField
            _unconditionalFields.reverse().forEach(function(childField) {
                var newFieldP = _fieldBuilder.buildFor(_fieldNanny, childField, readonly);
                _fieldNanny.addChildAfter(0, newFieldP);
                view.addTopField(newFieldP);
            });

            $.each(_conditionalFieldsMap, function(condition, childFields) {
                const newCondP = _conditionBuilder.build(condition, childFields, readonly, {
                    remove: _removeCondition
                });

                _condNanny.addChild(newCondP);
                view.addBottomCondition(newCondP);
            });
        }
    };
    _init();

    return {
        content: function() {
            return view.getContainer();
        },

        showErrors: function(errors) {
            _fieldNanny.getChildren().forEach(function(fieldP) {
                fieldP.showErrors(errors);
            });

            _condNanny.getChildren().forEach(function(condP) {
                condP.showErrors(errors);
            });
        },

        getFieldDefs: _getFieldDefs
    }
};

var NewConditionBuilder = function(core, parent) {
    return {
        build: function(condition, childFields, readonly, callbacks) {
            const newId = core.locallyUniqueId();
            const conditionP = new DefinitionConditionP(core, parent, condition, newId, childFields, readonly, callbacks);

            window.console.log(`new condition with id ${newId}`);

            return conditionP;
        }
    }
};

export default DefinitionConditionListP;
